















import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import {
  SocialSectionData,
  SocialSectionMethods,
  SocialSectionComputed,
  SocialSectionProps,
} from './SocialSection';
/**
 * `SocialSection Footer` - SocialSection for OneWeb - This component contains the links for the social networks.
 */

export default ComponentInitializeDispatcher.extend<
  SocialSectionData,
  SocialSectionMethods,
  SocialSectionComputed,
  SocialSectionProps
>({
  name: 'owc-social-section',
  mixins: [OwcDataComponent],
  computed: {
    socialLinks: function() {
      return this.componentData;
    },
  },
});
